export default {
    quotationInsuredList: [
        {
            familyType: 'single', // 被保人类型
            m_age: '0-59', // 主被保人年龄段
            p_age: '0', // 配偶年龄段
            c_num: '0', // 子女人数
            mult: '0', // 份数
            premium: '0', // 保费
            a_pm: '0', // 基础保费
            b_pm: '0' // 可选保费
        },
        {
            familyType: 'spf', // 被保人类型
            m_age: '0-59', // 主被保人年龄段
            p_age: '0', // 配偶年龄段
            c_num: '0', // 子女人数
            mult: '0', // 份数
            premium: '0', // 保费
            a_pm: '0', // 基础保费
            b_pm: '0' // 可选保费
        },
        {
            familyType: 'couple', // 被保人类型
            m_age: '0-59', // 主被保人年龄段
            p_age: '0-59', // 配偶年龄段
            c_num: '0', // 子女人数
            mult: '0', // 份数
            premium: '0', // 保费
            a_pm: '0', // 基础保费
            b_pm: '0' // 可选保费
        },
        {
            familyType: 'family', // 被保人类型
            m_age: '0-59', // 主被保人年龄段
            p_age: '0-59', // 配偶年龄段
            c_num: '0', // 子女人数
            mult: '0', // 份数
            premium: '0', // 保费
            a_pm: '0', // 基础保费
            b_pm: '0' // 可选保费
        }
    ],
    familyTypeCode: [
        {code: 'single', name: 'Single单人'},
        {code: 'spf', name: 'SPF亲子'},
        {code: 'couple', name: 'Couple夫妇'},
        {code: 'family', name: 'Family家庭'}
    ],
    ageCode: ['0-59', '60-65', '66-70', '71+'],
    planList:[
        {code:'Worldwide',name:'全球计划'},
        {code:'International Plus',name:'国际增强计划'},
        {code:'International',name:'国际计划'},
        {code:'Greater China Plus',name:'大中华增强计划'},
        {code:'Greater China',name:'大中华计划'},
        {code:'Mainland China Plus',name:'大陆增强计划'},
        {code:'Mainland China',name:'大陆计划'}
    ],
    tijianList:[{code:'1600',name:'1600元'},{code:'3200',name:'3200元'},{code:'5000',name:'5000元'}],
    yakeList:[{code:'2000',name:'2000元'},{code:'4000',name:'4000元'},{code:'9600',name:'9600元'},{code:'16000',name:'16000元'}],
}
